import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { openWhatsapp, BRAND } from "@/lib/contact";

export default function WhatsappFloating() {
    const [bubbleOpen, setBubbleOpen] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    // Show the chat-style bubble automatically after a brief delay
    useEffect(() => {
        const t = setTimeout(() => setBubbleOpen(true), 1800);
        return () => clearTimeout(t);
    }, []);

    const openChat = () =>
        openWhatsapp(
            "Hola Estela, vengo del sitio. Quisiera coordinar una consulta.",
        );

    return (
        <div
            data-testid="whatsapp-widget"
            className="fixed bottom-6 right-6 z-50 flex items-end gap-3"
        >
            {/* Chat-style speech bubble */}
            {bubbleOpen && !dismissed && (
                <div
                    data-testid="whatsapp-bubble"
                    className="relative max-w-[260px] sm:max-w-[300px] bg-white rounded-2xl rounded-br-md shadow-[0_18px_50px_-10px_rgba(10,38,20,0.25)] border border-[var(--uma-forest)]/8 p-4 pr-9 mb-1 cursor-pointer hover:-translate-y-0.5 transition-all duration-300"
                    onClick={openChat}
                    style={{
                        animation:
                            "uma-bubble-in 0.5s cubic-bezier(0.16,1,0.3,1) both",
                    }}
                >
                    <button
                        aria-label="Cerrar"
                        onClick={(e) => {
                            e.stopPropagation();
                            setDismissed(true);
                        }}
                        className="absolute top-2 right-2 w-6 h-6 rounded-full hover:bg-[var(--uma-cream-soft)] text-[var(--uma-text-soft)] flex items-center justify-center transition-colors"
                    >
                        <X className="h-3 w-3" />
                    </button>

                    <div className="flex items-center gap-2 mb-2">
                        <div className="relative w-8 h-8 rounded-full bg-[var(--uma-forest)] text-[var(--uma-gold)] flex items-center justify-center font-serif-display text-[14px] italic">
                            a
                            <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full bg-[#25D366] border-2 border-white" />
                        </div>
                        <div className="leading-tight">
                            <div className="text-[12px] font-medium text-[var(--uma-forest)]">
                                Estela Altez Palarin
                            </div>
                            <div className="text-[10px] text-[var(--uma-text-soft)]">
                                En línea · responde rápido
                            </div>
                        </div>
                    </div>

                    <p className="text-[13.5px] leading-relaxed text-[var(--uma-text)]">
                        <span className="font-medium">¡Hola! </span>
                        Escríbeme por WhatsApp y coordinamos una consulta sin
                        costo.
                    </p>

                    <div className="mt-3 inline-flex items-center gap-1.5 text-[12px] text-[#25D366] font-medium">
                        <MessageCircle className="h-3.5 w-3.5" />
                        {BRAND.whatsappDisplay}
                    </div>

                    {/* speech tail */}
                    <span
                        aria-hidden
                        className="absolute -bottom-1.5 right-3 w-3 h-3 bg-white border-r border-b border-[var(--uma-forest)]/8 rotate-45"
                    />
                </div>
            )}

            {/* Floating WhatsApp button */}
            <button
                type="button"
                data-testid="whatsapp-floating"
                aria-label="Contactar por WhatsApp"
                onClick={openChat}
                className="group relative w-15 h-15 sm:w-16 sm:h-16 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-[0_12px_36px_-6px_rgba(37,211,102,0.55)] hover:scale-105 active:scale-95 transition-all flex items-center justify-center flex-shrink-0"
                style={{ width: "60px", height: "60px" }}
            >
                <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
                <svg
                    viewBox="0 0 24 24"
                    className="w-7 h-7 fill-white relative"
                    aria-hidden="true"
                >
                    <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.51 5.26l-.999 3.648 3.978-.607z" />
                </svg>
                {!bubbleOpen && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-[var(--uma-gold)] text-[var(--uma-forest)] text-[11px] font-bold flex items-center justify-center border-2 border-white">
                        1
                    </span>
                )}
            </button>

            <style>{`
                @keyframes uma-bubble-in {
                    0% {
                        opacity: 0;
                        transform: translateY(12px) scale(0.96);
                    }
                    100% {
                        opacity: 1;
                        transform: translateY(0) scale(1);
                    }
                }
            `}</style>
        </div>
    );
}
